import http from './http';

export default {
    getAll() {
        return http.get('/wadaclassification');
    },
    create(wada) {
        return http.post('/wadaclassification', wada);
    },
    update(wada) {
        return http.put(`/wadaclassification/${wada.id}`, wada);
    },
};
